import { Category } from '@witkac/kartamiejska-shared';
import {
  CategoryResource,
  categoryResource
} from '@witkac/kartamiejska-resources';

import { EntityModule } from './entity.module';

/**
 * Moduł kategorii
 *
 * @export
 * @class CategoriesModule
 * @extends {AbstractModule<BenefitResource>}
 */
export class CategoriesModule extends EntityModule<
  Category,
  CategoryResource
> {}

export default new CategoriesModule(categoryResource);
